import { render, staticRenderFns } from "./TeacherIntroduce.vue?vue&type=template&id=3ff05343&scoped=true&"
import script from "./TeacherIntroduce.vue?vue&type=script&lang=js&"
export * from "./TeacherIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./TeacherIntroduce.vue?vue&type=style&index=0&id=3ff05343&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff05343",
  null
  
)

export default component.exports